import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import { Organization } from "../../../@types/organization";
import axiosInstance from "../../../utils/axiosConfig";
export const findOrganization = createAsyncThunk(
  "organizations/findOne",
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}organization/${id}`);
      return data as Organization;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
